import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonLight, ButtonStandard, formatMessage } from 'cw-ui-core';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';
import cx from 'classnames';
import css from './ResetPasswordUserDialog.scss';

export const RESET_PASSWORD_USER_DIALOG = 'RESET_PASSWORD_USER_DIALOG';

const ResetPasswordUserDialog = ({ usersCount = 0, onCancel, onReset }) => {
    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="reset"
            automationName="reset"
            className={css.resetButton}
            value={formatMessage(Locale.reset)}
            onClick={onReset}
        />,
    ];

    return (
        <Dialog
            dialogId={RESET_PASSWORD_USER_DIALOG}
            header={formatMessage(Locale.resetPassword)}
            buttons={dialogButtons}>
            <div className={cx(css.wrap, layoutCss.podCol)}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={RESET_PASSWORD_USER_DIALOG} />
                <Label value={formatMessage(Locale.resetConfirmation)} />
                <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
            </div>
        </Dialog>
    );
};

export default injectIntl(ResetPasswordUserDialog);
